export const DEFAULT_DATE_FAIL = 'Указана некорректная дата';

export const MIN_YEAR = 1920;

export const DEFAULT_SEPARATOR = '.';
